<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="formGroup"
    onsipFormTracking
    name="admin-voicemail-basic-edit"
    id="admin-voicemail-basic-edit"
    (ngSubmit)="onSubmit()"
  >
    <div onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">Mailbox owner</div>
          <onsip-address-autocomplete
            [addressTypes]="['user', 'group']"
            formControlName="mailboxOwner"
          >
          </onsip-address-autocomplete>
        </section>
        <section class="with-mat-form-field">
          <mat-form-field appearance="outline">
            <mat-label>Mailbox name</mat-label>
            <input
              matInput
              required
              type="text"
              formControlName="mailboxName"
              [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_EDIT_SHELVE_MAILBOX_NAME"
            />
            <mat-error>{{ getMailboxNameError() }}</mat-error>
          </mat-form-field>
        </section>
        <section class="mailbox-number-and-pin with-mat-form-field">
          <mat-form-field appearance="outline">
            <mat-label>Mailbox number</mat-label>
            <input
              matInput
              required
              type="text"
              formControlName="mailboxNumber"
              [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_EDIT_SHELVE_MAILBOX_NUMBER"
            />
            <mat-error>{{ getMailboxNumberError() }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "ONSIP_I18N.MAILBOX_PASSWORD_PIN" | translate }}</mat-label>
            <input matInput required type="text" formControlName="mailboxPin" />
            <mat-error>{{ getMailboxPinError() }}</mat-error>
          </mat-form-field>
        </section>
      </div>
      <div class="second-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">Notifications</div>
          <mat-form-field appearance="outline">
            <mat-label>Notification email</mat-label>
            <input matInput email type="text" formControlName="notificationEmail" />
            @if (formGroup.controls.notificationEmail.errors?.email) {
            <mat-error>
              {{ "ONSIP_I18N.MUST_BE_A_VALID_EMAIL_ADDRESS" | translate }}
            </mat-error>
            }
          </mat-form-field>
        </section>
        <section class="notification-checkboxes">
          <mat-checkbox formControlName="attachAsWav" color="primary">
            Attach message as a .wav file
          </mat-checkbox>
          <mat-checkbox formControlName="deleteAfterSending" color="primary">
            Delete message after sending
          </mat-checkbox>
        </section>
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">Message waiting notification</div>
          <onsip-address-autocomplete [addressTypes]="['user']" formControlName="mwi">
          </onsip-address-autocomplete>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button type="button" (click)="togglePanel()" color="primary">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_EDIT_SHELVE_SUBMIT"
      >
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
